import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import {
  ICustomer, ISampleCategory, ISamplePlaceOrderBody, ISampleFinish, ISampleSubCategoryRequestGrid1, ISampleRequestLabel,
  IState, ISampleSubCategory, SampleSubCategoryRequestGrid1, ISampleRegion, ISampleProductDetailItems, ICountry, IGetSampleCategoryExternalUser, IGetSampleSubCategoryByCategory
} from '../../../core/models';
import { MasterDataService } from '../../../core/services/master-data.service';
import { SelfUtilityService } from '../../../core/services/self-utility.service';
import { UserService } from '../../../core/services/user.service';
import { PanelBarComponent, PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { NotifyType } from '../../../core/enums/NotifyType';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { environment } from 'src/environments/environment';
import { OrderService } from '../../../core/services/order.service';
import { ProductSampleFulfillmentService } from '../../../core/services/product-sample-fulfillment.service';

@Component({
  selector: 'app-sample-request-new',
  templateUrl: './sample-request-new.component.html',
  styleUrls: ['./sample-request-new.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SampleRequestNewComponent implements OnInit {
  //#region Member Variables
  sampleRequestTxt: ISampleRequestLabel;
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;

  public sampleRequestForm: FormGroup;
  public shippingDetailsForm: FormGroup;
  public sampleRequestGridView: GridDataResult;
  public sampleRequestGridView1: GridDataResult;
  public sampleRequestGridData: ISampleProductDetailItems[] = [];
  public sampleRequestGridData1: ISampleSubCategoryRequestGrid1[] = [];
  public getSampleCategory: ISampleCategory[] = [];
  public getSampleCategoryFilterData: ISampleCategory[] = [];
  public getFinish: ISampleFinish[] = [];
  public getState: IState[] = [];
  public getCountry: ICountry[] = [];
  isCountryData: boolean = false;
  public getSampleRegion: ISampleRegion[] = [];
  public sampleRequestLoading: boolean;
  public maxQuantity: number;
  public confirmDialogOpened: boolean;
  public confirmImageDialogOpened: boolean = false;
  gridLargerImage: string = '';
  isGridLargerImage: boolean = false;
  public saveInProcess: boolean;
  imageUrl: string;
  billingAddress: ICustomer;
  sampleRequestOrderNum: string = '';
  isOnlyExtUser: boolean = false;
  isOnlyIntUser: boolean = false;
  isOnlyPDMUser: boolean = false;
  justTest = "       ";
  //#endregion

  //#region constructor ngOnInit
  constructor(private formBuilder: FormBuilder, private selfService: SelfUtilityService,
    private userService: UserService, private masterDataService: MasterDataService, private appNotifyService: AppNotifyService,
    private languageTranslationService: LanguageTranslationService, private orderService: OrderService,
    private productSampleFulfillmentService: ProductSampleFulfillmentService) {
  }

  ngOnInit(): void {
    this.loadLanguageTranslationData();
    this.imageUrl = environment.imageUrl;
    this.isOnlyExtUser = this.userService.isEXTUser();
    this.isOnlyPDMUser = this.userService.isPDMUser();
    this.isOnlyIntUser = this.userService.isIntUser();
    if (this.isOnlyPDMUser) {
      this.isOnlyExtUser = false;
      this.isOnlyIntUser = false;
    }

    if (this.isOnlyIntUser) {
      this.isOnlyExtUser = false;
      this.isOnlyPDMUser = false;
    }

    if (this.isOnlyExtUser) {
      this.isOnlyIntUser = false;
      this.isOnlyPDMUser = false;
    }
    

    this.sampleRequestForm = this.formBuilder.group({
      finishCategory: new FormControl(),
      finish: new FormControl(),
      // quantity: new FormControl()
    })
    this.shippingDetailsForm = this.formBuilder.group({
      companyName: new FormControl(),
      jobName: new FormControl(),
      addressLine1: new FormControl(),
      addressLine2: new FormControl(),
      phoneNumber: new FormControl(),
      city: new FormControl(),
      state: new FormControl(),
      zipCode: new FormControl(),
      contactFirstName: new FormControl(),
      contactLastName: new FormControl(),
      country: new FormControl(),
      ccEmail: new FormControl(),
      region: new FormControl(),
    })
    const body: IGetSampleCategoryExternalUser = {
      isOnlyExtUser: this.isOnlyExtUser
    }
    this.productSampleFulfillmentService.getActiveSampleCategories(body).subscribe((sampleCategories) => {
      this.getSampleCategory = sampleCategories as ISampleCategory[];
      this.getSampleCategoryFilterData = sampleCategories as ISampleCategory[];
    });
    this.loadAddressData(this.userService.readUserObject.customerNumber);
    this.getUserPhoneNumber(this.userService.readUserObject.userId);
  }
  //#endregion
  //#region language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "categoryLbl" },
      { controlName: "imageLbl" },
      { controlName: "finishCategoryLbl" },
      { controlName: "productLbl" },
      { controlName: "genderLbl" },
      { controlName: "sizeLbl" },
      { controlName: "quantityLbl" },
      { controlName: "addSelectionBtnLbl" },
      { controlName: "companyNameLbl" },
      { controlName: "addressLine1Lbl" },
      { controlName: "jobNameLbl" },
      { controlName: "addressLine2Lbl" },
      { controlName: "phoneNumberLbl" },
      { controlName: "cityLbl" },
      { controlName: "stateLbl" },
      { controlName: "zipCodeLbl" },
      { controlName: "info1Lbl" },
      { controlName: "info2Lbl" },
      { controlName: "info3Lbl" },
      { controlName: "sampleSelectionLbl" },
      { controlName: "selectionLbl1" },
      { controlName: "continueLbl" },
      { controlName: "reviewSelectionLbl" },
      { controlName: "shippingDetailsLbl" },
      { controlName: "phoneNumberValidationLbl" },
      { controlName: "cancelLbl" },
      { controlName: "placeOrderLbl" },
      { controlName: "submitResponseLbl1" },
      { controlName: "contactFirstNameLbl" },
      { controlName: "contactLastNameLbl" },
      { controlName: "colorCodeLbl" },
      { controlName: "stockNumLbl" },
      { controlName: "onBackOrderLbl" },
      { controlName: "maxQtyLbl" },
      { controlName: "countryLbl" },
      { controlName: "ccEmailLbl" },
      { controlName: "regionLbl" },
      { controlName: "info3Lbl" },
      { controlName: "ccEmailValidationLbl1" }
    ];
    const componentName = "samplerequest";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.sampleRequestTxt = response[response.length - 1];
    }    
  }
  //#endregion
  //#region label/variable declaration
  sampleRequestGrid = {
    imageLbl: "Image",
    categoryLbl: "Category",
    finishCategoryLbl: "Select Category",
    productLbl: "Product",
    genderLbl: "Gender",
    sizeLbl: "Size",
    quantityLbl: "Quantity",
    addSelectionBtnLbl: "Add Selection",
    sampleSelectionLbl: 'SAMPLE SELECTION',
    selectionLbl1: 'Action',
    continueLbl: 'Continue',
    reviewSelectionLbl: 'REVIEW SELECTION',
    shippingDetailsLbl: 'SHIPPING DETAILS',
    phoneNumberValidationLbl: 'Phone number length should be minimum 10',
    cancelLbl: 'Cancel',
    placeOrderLbl: 'Place Order',
    submitResponseLbl1: 'Thank you for shopping with us. Your Sample request order has been placed successfully',
    addedSucccessfullyLbl: "Added successfully!",
    colorCodeLbl: "Color Code",
    stockNumLbl: "Stock#",
    onBackOrderLbl: "On Backorder",
    maxQtyLbl: "Max Order",
    ccEmailValidationLbl1: 'Please enter emails in correct format with multiple entries separated by comma (ex: test@arconic.com,testNew@arconic.com)',
  }

  sampleItems = {
    isEmptyFinishCategory: false,
    isEmptyFinish: false,
    isEmptyQuantity: false,
    isSubmitted: false,
    isSampleSelectionPanelValid: false,
    isReviewSelectionPanelValid: false,
    isContinueClicked: false,
    isContinue: false
  }
  //#endregion
  //#region validation 

  //#endregion
  //#region filter
  handleFinishCategoryFilter(event) {
    if (!event) {
      this.getSampleCategory = this.getSampleCategoryFilterData;
      return;
    }
    const filterArray = this.getSampleCategoryFilterData.filter(x => x.categoryName != null);
    this.getSampleCategory = filterArray.filter(
      (s) => s.categoryName.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );    
  }
  //#endregion
  //#region sorting,filtering,pagination of grid
  loadSampleRequestGrid() {
    this.sampleRequestGridView = process(this.sampleRequestGridData, this.sampleRequestGridstate);
  }
  protected sampleRequestGridstate: State = {
    sort: [],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  protected sampleRequestGridSortChange(sort): void {
    this.sampleRequestGridstate.sort = sort;
    this.loadSampleRequestGrid();
  }
  protected sampleRequestGridPageChange({ skip, take }: PageChangeEvent): void {
    this.sampleRequestGridstate.skip = skip;
    this.sampleRequestGridstate.take = take;
    this.loadSampleRequestGrid();

  }
  protected sampleRequestDataStateChange(state: DataStateChangeEvent): void {
    this.sampleRequestGridstate = state;
    this.loadSampleRequestGrid();
  }

  //#endregion

  //#region delete sample request row
  deleteSample(rowIndex) {
    this.sampleRequestGridData.splice(rowIndex, 1);
    this.loadSampleRequestGrid();
  }
  //#endregion
  //#region sample request functionality

  finishCategoryLeave() {
    const controls = this.sampleRequestForm.controls;
    if (controls.finishCategory.value && controls.finishCategory.value.length > 0) {
      const body: IGetSampleSubCategoryByCategory = {
        sampleCategory: controls.finishCategory.value,
        isOnlyExtUser: this.isOnlyExtUser,
        isOnlyIntUser: this.isOnlyIntUser,
        isOnlyPDMUser: this.isOnlyPDMUser
      }
      this.productSampleFulfillmentService.getActiveSampleSubCategoriesByCatgeory(body).subscribe(response => {
        if (response) {
          this.sampleRequestGridData1 = response;
          this.loadSampleRequestGrid1();
        }

      })

    }
    else {
      this.sampleRequestGridData1 = [];
      this.loadSampleRequestGrid1();
    }
    this.sampleRequestGridstate1.skip = 0;
    this.loadSampleRequestGrid1();
  }
  //#endregion
  //#region sample request grid 1 operations
  //#region Grid dropdown change 
  handleGenderChange(event, dataItem) {
    const selectedGender = event.value;
    if (selectedGender) {
      dataItem.selectedGender = selectedGender;
    }
  }
  handleSizeChange(event, dataItem) {
    const selectedSize = event.value;
    if (selectedSize) {
      dataItem.selectedSize = selectedSize;
    }
  }
  handleItemQtyChanged(event, dataItem) {
    if (dataItem.maxQtyCanBeOrdered >= event) {
      dataItem.quantity = event;
    } else {
      dataItem.quantity = event;
      this.appNotifyService.notify(NotifyType.INFO, 'Maximum quantity of this item is ' + dataItem.maxQtyCanBeOrdered);
    }

  }
  //#endregion
  //#region sorting,filtering,pagination of grid
  loadSampleRequestGrid1() {
    this.sampleRequestGridView1 = process(this.sampleRequestGridData1, this.sampleRequestGridstate1);
  }
  protected sampleRequestGridstate1: State = {
    sort: [],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  protected sampleRequestGridSortChange1(sort): void {
    this.sampleRequestGridstate1.sort = sort;
    this.loadSampleRequestGrid1();
  }
  protected sampleRequestGridPageChange1({ skip, take }: PageChangeEvent): void {
    this.sampleRequestGridstate1.skip = skip;
    this.sampleRequestGridstate1.take = take;
    this.loadSampleRequestGrid1();

  }
  protected sampleRequestDataStateChange1(state: DataStateChangeEvent): void {
    this.sampleRequestGridstate1 = state;
    this.loadSampleRequestGrid1();
  }

  //#endregion
  //#region Add sample selection button functionality
  rowItems: SampleSubCategoryRequestGrid1;

  addSelection(item: any) {
    const rowItems = new SampleSubCategoryRequestGrid1();
    item.isEmptyQuantity = false as boolean;
    var type = "";    
    if (item.categoryName === "KNA Clothing" && item.categoryId === 12000) {    //checking validation only for KNA Clothing
      if (!item.selectedGender) {
        item.isEmptyGender = true as boolean;
        return;
      } else {
        //rowItems.gender = item.selectedGender;
      }
      if (!item.selectedSize) {
        item.isEmptySizes = true as boolean;
        return;
      } else {
        //rowItems.size = item.selectedSize;
      }
      type = "KNA Clothing";
    } else {
      type = "Other";
    }
    if (item.quantity < 1) {
      item.isEmptyQuantity = true as boolean;
      return;
    } else {
      rowItems.quantity = item.quantity;
    }
    rowItems.imagePath = item.imagePath;
    rowItems.r_VALUE = item.r_VALUE;
    rowItems.g_VALUE = item.g_VALUE;
    rowItems.b_VALUE = item.b_VALUE;
    rowItems.absoluteURL = item.absoluteURL;
    rowItems.categoryName = item.categoryName;
    rowItems.subCategoryDescription = item.subCategoryDescription;
    rowItems.categoryId = item.categoryId;
    rowItems.subCategoryId = item.subCategoryId;
    rowItems.sku = item.sku;
    rowItems.colorCode = item.colorCode;
    rowItems.stockNum = item.stockNum;
    rowItems.onBackOrder = item.onBackOrder;
    rowItems.maxQtyCanBeOrdered = item.maxQtyCanBeOrdered;
    rowItems.width = item.width;
    rowItems.length = item.length;
    rowItems.height = item.height;
    rowItems.weight = item.weight;
    var isRowExists = false;
    if (this.sampleRequestGridData.length > 0) {
      //checking duplicate row is there in second grid
      for (var i = 0; i < this.sampleRequestGridData.length; i++) {
        if (type == 'KNA Clothing') {
          if (this.sampleRequestGridData[i].categoryId == item.categoryId &&
            this.sampleRequestGridData[i].categoryName == item.categoryName 
            //&& this.sampleRequestGridData[i].gender == item.selectedGender && this.sampleRequestGridData[i].size == item.selectedSize
            ) {
            if (this.sampleRequestGridData[i].quantity + item.quantity <= item.maxQtyCanBeOrdered) {
              this.sampleRequestGridData[i].quantity += item.quantity; //Updating the quantity in second table existing row
              isRowExists = true;
            } else {
              this.appNotifyService.notify(NotifyType.INFO, 'Maximum quantity exceeded to add this item');
              return;
            }

          } else {
            if (item.maxQtyCanBeOrdered < item.quantity) {
              this.appNotifyService.notify(NotifyType.INFO, 'Maximum quantity of this item is ' + item.maxQtyCanBeOrdered);
              return;
            }
          }
        } else {
          if (this.sampleRequestGridData[i].categoryId == item.categoryId &&
            this.sampleRequestGridData[i].subCategoryDescription == item.subCategoryDescription
            && this.sampleRequestGridData[i].stockNum == item.stockNum) {
            if (this.sampleRequestGridData[i].quantity + item.quantity <= item.maxQtyCanBeOrdered) {
              this.sampleRequestGridData[i].quantity += item.quantity; //Updating the quantity in second table existing row
              isRowExists = true;
            } else {
              this.appNotifyService.notify(NotifyType.INFO, 'Maximum quantity exceeded to add this item');
              return;
            }
          } else {
            if (item.maxQtyCanBeOrdered < item.quantity) {
              this.appNotifyService.notify(NotifyType.INFO, 'Maximum quantity of this item is ' + item.maxQtyCanBeOrdered);
              return;
            }
          }
        }
      }
    } else {
      if (item.maxQtyCanBeOrdered < item.quantity) {
        this.appNotifyService.notify(NotifyType.INFO, 'Maximum quantity for this item is ' + item.maxQtyCanBeOrdered);
        return;
      }
    }
    if (isRowExists == true) {
      this.loadSampleRequestGrid(); //just refresh the second grid data
    } else {
      this.sampleRequestGridData.push(rowItems);    //Push the rowItems data in next grid here
      this.loadSampleRequestGrid();
    }
    this.appNotifyService.notify(NotifyType.SUCCESS, 'Added successfully!');
    item.isEmptyQuantity = false as boolean;
    item.quantity = 1;
  }
  //#endregion
  //#endregion

  //#region shipping address panel operations
  continueToReviewPanel() {
    this.sampleItems.isContinueClicked = true;
    if (this.sampleRequestGridData1.length > 0) {
      this.sampleItems.isSampleSelectionPanelValid = true;
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[1].expanded = true;
      this.panel.childrenItems[1].selected = true;
    } else {
      this.sampleItems.isSampleSelectionPanelValid = false;
    }
    //this.sampleRequestForm.reset();
    //this.sampleItems.isEmptyFinishCategory = false;
    //this.sampleItems.isEmptyFinish = false;
    //this.sampleItems.isEmptyQuantity = false;
    this.sampleItems.isSubmitted = false;

  }
  continueToAddressPanel() {
    this.sampleItems.isContinue = true;
    if (this.sampleRequestGridData.length > 0) {
      this.sampleItems.isReviewSelectionPanelValid = true;
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[2].expanded = true;
      this.panel.childrenItems[2].selected = true;
    } else {
      this.sampleItems.isReviewSelectionPanelValid = false;
    }

    this.sampleItems.isSubmitted = false;
  }

  //#region label and variable declaration
  shippingDetails = {
    companyNameLbl: "Company Name",
    addressLine1Lbl: "Address Line 1",
    jobNameLbl: "Job Name",
    addressLine2Lbl: "Address Line 2",
    phoneNumberLbl1: "Contact Phone Number",
    cityLbl: "City",
    stateLbl: "State",
    zipCodeLbl: "Zip Code",
    contactFirstNameLbl: "Contact First Name",
    contactLastNameLbl: "Contact Last Name",
    isEmptyCompanyName: false,
    isEmptyJobName: false,
    isEmptyAddress1: false,
    isEmptyAddress2: false,
    isEmptyPhoneNumber: false,
    isInvalidPhoneNumber: false,
    isEmptyCity: false,
    isEmptyState: false,
    isEmptyZipCode: false,
    isEmptycontactFirstName: false,
    isEmptycontactLastName: false,
    isSubmitted: false,
    isShippingDetailsPanelValid: false,
    isInvalidCCEmail: false,
    info1Lbl: "Typically orders received before 2:00 PM EST will ship the same day.",
    info2Lbl: "Do not order Color Samples for Stock.  Contact your Kawneer representative.",
    info3Lbl: "To request an expedited shipment, please email expedite@shorewoodind.com.  Please include Order Number.",
    countryLbl: "Country",
    ccEmailLbl: "CC Email",
    regionLbl: "Region",
    isEmptyCountry: false,
    isEmptyRegion: false,
  }
  //#endregion
 
  public checkMultipleCCEmail(email) {
    const regExp = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/;
    return regExp.test(String(email).toLowerCase());
  }
  //#region place order button operation
  protected validateShippingDetailsForm(): boolean {
    let isValid = true;
    const controls = this.shippingDetailsForm.controls;
    if (this.shippingDetails.isSubmitted) {
      if (controls.companyName.value) {
        this.shippingDetails.isEmptyCompanyName = false;
      } else {
        this.shippingDetails.isEmptyCompanyName = true;
        isValid = false;
      }
      if (controls.jobName.value) {
        this.shippingDetails.isEmptyJobName = false;
      } else {
        this.shippingDetails.isEmptyJobName = true;
        isValid = false;
      }
      if (controls.addressLine1.value) {
        this.shippingDetails.isEmptyAddress1 = false;
      } else {
        this.shippingDetails.isEmptyAddress1 = true;
        isValid = false;
      }
      //if (controls.addressLine2.value) {
      //  this.shippingDetails.isEmptyAddress2 = false;
      //} else {
      //  this.shippingDetails.isEmptyAddress2 = true;
      //  isValid = false;
      //}
      if (controls.phoneNumber.value) {
        this.shippingDetails.isEmptyPhoneNumber = false;
        if ((controls.phoneNumber.value as string).toString().length !== 10) {
          this.shippingDetails.isInvalidPhoneNumber = true;
          isValid = false;
        } else {
          this.shippingDetails.isInvalidPhoneNumber = false;
        }
      } else {
        this.shippingDetails.isEmptyPhoneNumber = true;
        isValid = false;
      }
      if (controls.city.value) {
        this.shippingDetails.isEmptyCity = false;
      } else {
        this.shippingDetails.isEmptyCity = true;
        isValid = false;
      }
      if (controls.state.value && controls.state.value.stateCode) {
        this.shippingDetails.isEmptyState = false;
      } else {
        this.shippingDetails.isEmptyState = true;
        isValid = false;
      }
      if (controls.zipCode.value) {
        this.shippingDetails.isEmptyZipCode = false;
      } else {
        this.shippingDetails.isEmptyZipCode = true;
        isValid = false;
      }
      if (controls.contactFirstName.value) {
        this.shippingDetails.isEmptycontactFirstName = false;
      } else {
        this.shippingDetails.isEmptycontactFirstName = true;
        isValid = false;
      }
      if (controls.contactLastName.value) {
        this.shippingDetails.isEmptycontactLastName = false;
      } else {
        this.shippingDetails.isEmptycontactLastName = true;
        isValid = false;
      }
      if (this.isCountryData) {
        if (controls.country.value) {
          this.shippingDetails.isEmptyCountry = false;
        } else {
          this.shippingDetails.isEmptyCountry = true;
          isValid = false;
        }
      }      
      if (controls.region.value && controls.region.value.regionCode) {
        this.shippingDetails.isEmptyRegion = false;
      } else {
        this.shippingDetails.isEmptyRegion = true;
        isValid = false;
      }
      
      if (controls.ccEmail.value) {
        this.shippingDetails.isInvalidCCEmail = false;
        if ((controls.ccEmail.value as string).toString().trim().length > 0) {
          const res = this.checkMultipleCCEmail(controls.ccEmail.value.toString().trim());
          if (res) {
            this.shippingDetails.isInvalidCCEmail = false;
          } else {
            this.shippingDetails.isInvalidCCEmail = true;
            isValid = false;
          }
        }
      } else {
        this.shippingDetails.isInvalidCCEmail = false;
      }
      
    }
    return isValid;
  }
  placeOrder() {
    this.shippingDetails.isSubmitted = true;
    if (!this.validateShippingDetailsForm()) {
      this.shippingDetails.isShippingDetailsPanelValid = false;
      return;
    }
    if (this.sampleRequestGridData.length > 0) {
      this.sampleItems.isSampleSelectionPanelValid = true;
      this.shippingDetails.isShippingDetailsPanelValid = true;
      this.saveInProcess = true;
      const controls = this.shippingDetailsForm.controls;
      const body: ISamplePlaceOrderBody = {
        sampleRequestItems: this.sampleRequestGridData,
        companyName: controls.companyName.value,
        jobName: controls.jobName.value,
        addressLine1: controls.addressLine1.value,
        addressLine2: controls.addressLine2.value,
        phoneNumber: controls.phoneNumber.value.toString(),
        city: controls.city.value,
        state: controls.state.value ? controls.state.value.stateDescription : "",
        zipCode: controls.zipCode.value,        
        customerNumber: this.userService.readUserObject.customerNumber,
        languageCode: localStorage.getItem('language'),
        stateCode: controls.state.value ? controls.state.value.stateCode : "",
        contactFirstName: controls.contactFirstName.value,
        contactLastName: controls.contactLastName.value,
        country: controls.country.value ? controls.country.value.countryCode : "",
        ccEmail: controls.ccEmail.value,
        region: controls.region.value ? controls.region.value.regionDescription : "",       
      }
      this.productSampleFulfillmentService.placeOrderSampleRequest(body).subscribe(response => {
        this.sampleRequestGrid.submitResponseLbl1 = "Thank you for shopping with us. Your Sample request order has been placed successfully";
        this.sampleRequestOrderNum = response.orderNumber;
        this.confirmDialogOpened = true;
        this.sampleRequestForm.reset();
        this.shippingDetailsForm.reset();
        this.setValueInShippingForm();
        this.sampleRequestGridData1 = [];
        this.sampleRequestGridData = [];
        this.loadSampleRequestGrid1();
        this.loadSampleRequestGrid();
        this.shippingDetails.isSubmitted = false;
        this.sampleItems.isContinueClicked = false;
        this.sampleItems.isContinue = false;
        this.sampleItems.isReviewSelectionPanelValid = false;
        this.sampleItems.isSampleSelectionPanelValid = false;
        this.saveInProcess = false;
        this.loadAddressData(this.userService.readUserObject.customerNumber);
        this.getUserPhoneNumber(this.userService.readUserObject.userId);
        this.panel.childrenItems.forEach(item => {
          if (item.expanded) {
            item.expanded = false;
            item.selected = false;
          }
        });
        this.panel.childrenItems[0].expanded = true;
        this.panel.childrenItems[1].expanded = true;
        this.panel.childrenItems[2].expanded = false;
      })
    }
    else {
      this.shippingDetails.isShippingDetailsPanelValid = true;
      this.sampleItems.isSampleSelectionPanelValid = false;
      this.sampleItems.isContinueClicked = true;
    }
  }
  //sets value in controls from localstorage
  setValueInShippingForm() {
    const data = this.userService.readUserObject;
    if (data) {
      this.shippingDetailsForm.controls.companyName.setValue(data.customerName);
      this.shippingDetailsForm.controls.jobName.setValue("");
      if (this.billingAddress) {
        this.shippingDetailsForm.controls.addressLine1.setValue(this.billingAddress.addressLine1);
        this.shippingDetailsForm.controls.addressLine2.setValue(this.billingAddress.addressLine2);
        //this.shippingDetailsForm.controls.phoneNumber.setValue("");
        this.shippingDetailsForm.controls.city.setValue(this.billingAddress.city);
        //this.shippingDetailsForm.controls.state.setValue(data.state),
        this.shippingDetailsForm.controls.zipCode.setValue(this.billingAddress.zipCode);
        //this.shippingDetailsForm.controls.country.setValue(this.billingAddress.country);
        //this.shippingDetailsForm.controls.region.setValue(this.billingAddress.regionCode);
      }
      this.shippingDetailsForm.controls.contactFirstName.setValue(data.userFirstName);
      this.shippingDetailsForm.controls.contactLastName.setValue(data.userLastName);
    }    
  }

  cancelPlaceOrder() {
    this.setValueInShippingForm();
    this.sampleRequestGridData1 = [];
    this.sampleRequestGridData = [];
    this.shippingDetails.isSubmitted = false;
    this.sampleItems.isContinueClicked = false;
    this.saveInProcess = false;
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    this.sampleRequestOrderNum = '';
  }
  //#endregion
  //#endregion
  confirmDialogClose() {
    this.confirmDialogOpened = false;
    this.sampleRequestOrderNum = '';
  }
  confirmImageDialogClose() {
    this.confirmImageDialogOpened = false;
  }
  imageLarge(item: ISampleSubCategory, path: string) {
    this.confirmImageDialogOpened = true;
    if (path == "absolute") {
      this.isGridLargerImage = true;
      this.gridLargerImage = item.absoluteURL;
    }
    else if (path == 'path') {
      this.isGridLargerImage = true;
      this.gridLargerImage = this.imageUrl + '/' + item.imagePath;
    }
    else {
      this.isGridLargerImage = false;
      this.gridLargerImage = "rgb(" + item.r_VALUE + ", " + item.g_VALUE + ", " + item.b_VALUE + ")";      
    }
      
  }
  public getColorString(r: number, g: number, b: number): string {
    var a = "'rgb(" + r + "," + g + "," + b + ")'";
    return "'rgb(" + r + "," + g + "," + b + ")'";
  }

  public onFilterSampleRequest(inputValue: string): void {

    this.sampleRequestGridView1 = process(this.sampleRequestGridData1, {
      filter: {
        logic: "or",
        filters: [

          {
            field: "finishCategory",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "finish",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });
    if (!inputValue) {
      this.sampleRequestGridstate1.skip = 0;
      this.sampleRequestGridstate1.take = 10;
      this.loadSampleRequestGrid1();
    }
  }

  public onFilterReviewSampleRequest(inputValue: string): void {
    this.sampleRequestGridView = process(this.sampleRequestGridData, {
      filter: {
        logic: "or",
        filters: [

          {
            field: "finishCategory",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "finish",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });
    if (!inputValue) {
      this.sampleRequestGridstate.skip = 0;
      this.sampleRequestGridstate.take = 10;
      this.loadSampleRequestGrid();
    }
  }
  setOtherCountry() {
    this.getCountry.push({ countryCode: "CO", countryName: "Other Country1", states: [] });
    this.getCountry.push({ countryCode: "CO", countryName: "Other Country2", states: [] });
    this.getCountry.push({ countryCode: "CO", countryName: "Other Country3", states: [] });
    this.getCountry.push({ countryCode: "CO", countryName: "Other Country4", states: [] });
  }
  getUserPhoneNumber(userId : string) {
    this.userService.loadUserDetailsForEdit(userId).subscribe(response => {
      if (response) {
        if (response.user.userPhoneNumber)
          this.shippingDetailsForm.controls.phoneNumber.setValue(Number(response.user.userPhoneNumber));
        else
          this.shippingDetailsForm.controls.phoneNumber.setValue("");
      }      
    });
  
  }  

  loadAddressData(id) {
    this.orderService.getAddress(id as number).subscribe((response: ICustomer) => {
      this.billingAddress = response;
      this.masterDataService.GetStates().subscribe(response => {
        this.getState = response;
        this.setValueInShippingForm();
        if (this.billingAddress.state) {
          var stateVal = this.getState.filter(s => s.stateCode && s.stateCode.trim() === this.billingAddress.state.trim()).map(r => {
            return { stateDescription: r.stateDescription, stateCode: r.stateCode };
          });
          if (stateVal)
            this.shippingDetailsForm.controls.state.setValue(stateVal[0]);
        }
      });

      this.masterDataService.GetCountries().subscribe(response => {
        this.getCountry = response;
        //this.setOtherCountry();
        if (this.billingAddress.country) {
          for (let [key, value] of Object.entries(this.getCountry)) {
            for (var stateVal of value.states) {
              if (this.billingAddress.state) {
                if (stateVal.stateCode.trim() === this.billingAddress.state.trim()) {
                  var tempCountryCode = value.countryCode;
                  var countryVal = this.getCountry.filter(s => s.countryCode && s.countryCode.trim() === tempCountryCode.trim()).map(r => {
                    return { countryDescription: r.countryName, countryCode: r.countryCode };
                  });
                  if (countryVal) {
                    this.shippingDetailsForm.controls.country.setValue(countryVal[0]);
                    this.isCountryData = true;
                    break;
                  }
                }
              }
            }
          }
        }
        //else { this.shippingDetailsForm.controls.country.setValue(this.getCountry[0]); }
      });

      this.productSampleFulfillmentService.GetSampleRegions().subscribe(response => {
        this.getSampleRegion = response;
        var tempRegioncode = '';
        if (id == '100195' || id == '100238') {
          if (this.userService.readUserObject.userRegion)
            tempRegioncode = this.userService.readUserObject.userRegion.trim();
          else
            tempRegioncode = this.getSampleRegion[0].regionCode;
        }
        else if (this.billingAddress.regionCode) {
          tempRegioncode = this.billingAddress.regionCode.trim();
        }
        else {
          tempRegioncode = this.getSampleRegion[0].regionCode;
        }
        var regionVal = this.getSampleRegion.filter(s => s.regionCode && s.regionCode.trim() === tempRegioncode).map(r => {
          return { regionDescription: r.regionDescription, regionCode: r.regionCode };
        });
        if (regionVal)
          this.shippingDetailsForm.controls.region.setValue(regionVal[0]);

      });


    })
  }
  getCountryByState(event) {
    if (event) {
      const controls = this.shippingDetailsForm.controls;
      var stateCodeObj = controls.state.value ? controls.state.value.stateCode : "";
      if (stateCodeObj == "OT") {
        this.isCountryData = false;
        this.shippingDetailsForm.controls.country.setValue(null);
        return;
      }
      for (let [key, value] of Object.entries(this.getCountry)) {
        for (var stateVal of value.states) {
          if (stateVal.stateCode.trim() === stateCodeObj.trim()) {
            var tempCountryCode = value.countryCode;
            var countryVal = this.getCountry.filter(s => s.countryCode && s.countryCode.trim() === tempCountryCode.trim()).map(r => {
              return { countryDescription: r.countryName, countryCode: r.countryCode };
            });
            if (countryVal) {
              this.shippingDetailsForm.controls.country.setValue(countryVal[0]);
              this.isCountryData = true;
              break;
            }
          }
        }
      }
    }
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
